import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as GatewayTimeoutImage } from 'assets/svg/502-bad-gateway.svg'
import { ReactComponent as FixtabLogoWithTextImage } from 'assets/svg/fixtab-logo-with-text.svg'

import { currentVersion } from 'helpers/common'
import { handleTryAgain } from './management'

export const Error502Container = (): JSX.Element => {
  const { t } = useTranslation(['common', 'error'])

  return (
    <>
      <div className='con__error'>
        <div className='con__error__header'>
          <FixtabLogoWithTextImage />
        </div>

        <div className='con__error__body'>
          <GatewayTimeoutImage />

          <span className='con__error__title'>
            {t('error:badGateway.title')}
          </span>

          <span className='con__error__content'>
            {t('error:badGateway.content')}
          </span>

          <span className='con__error__code'>{t('error:badGateway.code')}</span>

          <button className='con__error__btn' onClick={handleTryAgain}>
            <span>{t('common:tryAgain.label')}</span>
          </button>
        </div>

        <div className='con__error__footer'>
          <span>
            {t('common:version.label')} {currentVersion}
          </span>
        </div>
      </div>
    </>
  )
}
